export default "__VITE_ASSET__COqighA1__"